import { object } from 'prop-types'

import moment from 'moment'

import compose from 'recompose/compose'
import getContext from 'recompose/getContext'
import withState from 'recompose/withState'
import withHandlers from 'recompose/withHandlers'

import View from './DateRow'


const createGate = ({ data: { dateStr }, time, createGate, setShowInput }) => async () => {
  const datePart = moment(dateStr)
  const timePart = moment(time)

  const gateTime = moment({
    year: datePart.year(),
    month: datePart.month(),
    date: datePart.date(),
    hour: timePart.hour(),
    minute: timePart.minute(),
  })

  if (gateTime.isValid()) {
    setShowInput(false)
    await createGate(gateTime)
  } else {
    alert('輸入時間錯誤')
  }
}

const createComment = ({ data: { dateStr }, comment, setComment, createComment }) => async text => {
  const date = moment(dateStr).toDate()

  const doc = await createComment({ ...comment, date, comment: text })
  setComment(doc)
}

const DateRow = compose(
  getContext({ server: object }),

  withState('showInput', 'setShowInput', false),
  withState('time', 'setTime', null),

  withHandlers({ createGate, createComment }),
)(View)

DateRow.displayName = 'DateRow'

export default DateRow



// WEBPACK FOOTER //
// ./src/components/AttendanceChecker/DateRow/index.js